var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"copyright",attrs:{"cols":"12"}},[_c('p',[_vm._v(" Copyright "+_vm._s(_vm.app_name)+" - 2022. Todos los derechos reservados ")])])}
var staticRenderFns = []

export { render, staticRenderFns }